import { useEffect } from 'react';

/**
 * Lightweight per-page SEO hook.
 * Updates <title>, meta description, canonical, OG/Twitter tags on route changes.
 */
const setMeta = (selector, attr, value) => {
  let el = document.querySelector(selector);
  if (!el) {
    el = document.createElement(selector.startsWith('meta') ? 'meta' : 'link');
    const parts = selector.match(/\[(\w+)="([^"]+)"\]/);
    if (parts) el.setAttribute(parts[1], parts[2]);
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
};

const DEFAULT_OG_IMAGE =
  'https://static.wixstatic.com/media/eeca94_6de20638dee54508bae0914144fc733e~mv2.jpg/v1/fill/w_1200,h_630,fp_0.53_0.57,q_85,enc_avif,quality_auto/eeca94_6de20638dee54508bae0914144fc733e~mv2.jpg';

const SITE_NAME = 'Membratek';
const BASE_URL = 'https://membratek.com';

// Module constants and setMeta are stable. Only page inputs are reactive dependencies.
export const useSeo = ({ title, description, path = '', image }) => {
  useEffect(() => {
    const fullTitle = title
      ? `${title} | ${SITE_NAME}`
      : `${SITE_NAME} | Membran Yapilar & Asma Germe Mimarisi`;
    document.title = fullTitle;

    const desc =
      description ||
      '15 yillik tecrubeyle asma germe, membran yapi, celik konstruksiyon, depo cadiri ve gelgelendirme sistemleri. 500+ prestijli proje, ISO 9001 belgeli.';
    const url = `${BASE_URL}${path}`;
    const img = image || DEFAULT_OG_IMAGE;

    setMeta('meta[name="description"]', 'content', desc);
    setMeta('link[rel="canonical"]', 'href', url);

    setMeta('meta[property="og:title"]', 'content', fullTitle);
    setMeta('meta[property="og:description"]', 'content', desc);
    setMeta('meta[property="og:url"]', 'content', url);
    setMeta('meta[property="og:image"]', 'content', img);

    setMeta('meta[name="twitter:title"]', 'content', fullTitle);
    setMeta('meta[name="twitter:description"]', 'content', desc);
    setMeta('meta[name="twitter:image"]', 'content', img);
  }, [title, description, path, image]);
};
